import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IBusinessPlanDetail } from './business-plant-detail.models';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from 'src/app/core/services/endpoints-configurations/endpoint-constants';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';

@Injectable({ providedIn: 'root' })
export class BusinessPlantDetailStoreService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  constructor(private repo: HttpClientRequestService) {}

  getBusinessPlanDetail(request: { BusinessPlanGuid: string }): Observable<IBusinessPlanDetail> {
    const url = EndpointConstants.ApiBusinessplandetail;
    return this.repo.post<IBusinessPlanDetail>(url, request);
  }
}
